var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('BannerVue',{attrs:{"imgurl":_vm.bannerObj.bannerImgURL,"text":_vm.bannerObj.text,"big":""}}),_c('DesVue'),_c('TabVue'),_c('Wwd')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }